import CheckboxGroup from 'packages/checkbox/src/checkbox-group';

export default CheckboxGroup;



// WEBPACK FOOTER //
// ./packages/checkbox-group/index.js